export default __webpack_public_path__ + "static/media/trangiaNaturGallery.a623b8d8.jpg";